import React from "react";

export default function AboutSection({ className }) {
  return (
    <section className={`about-three pb-8 rpy-100 ${className || ""}`}>
      <div className="container">
        <div className="row align-items-center mission-vision-section">
          <div className="col-lg-7 col-md-12">
            <div className="about-content pl-70 rpl-0 wow fadeInRight delay-0-2s">
              <h2 className="pt-3 sub-title blue-text">Vision</h2>
              <p className="about-mission">
                Our solutions deliver value and innovation. This ensures
                continued growth and success for our customers and stakeholders
                alike. Together, we look forward to shaping the future of a
                NavIC-connected world. To connect people, processes, and
                technology via NavIC-based applications with a concentrated
                focus on quality, R&D, and customer satisfaction
              </p>
            </div>
          </div>
          <div className="col-lg-5 col-md-12 mb-4 mb-lg-0">
            {/* <div className="mission-vision-image-wrapper">
              <img
                src={require(`../../assets/images/about/mission.jpg`).default}
                alt="Mission"
                className="img-fluid mission-image"
              />
            </div> */}
            <div className="mission-vision-image">
              {/* <div className="about-three-image rmb-60 mr-10 rmr-0 wow fadeInLeft delay-0-2s pt-200 ">
                <img
                  src={require(`../../assets/images/about/vission.png`).default}
                  alt="About"
                  className="ml-40"
                />
              </div> */}
              <div className="mission-vision-image-wrapper">
                <img
                  src={require(`../../assets/images/about/vission.png`).default}
                  alt="Vision"
                  className="img-fluid mission-image"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row align-items-center mission-vision-section">
          <div className="col-lg-5 col-md-12 mb-4 mb-lg-0 mission-image">
            <div className="mission-vision-image-wrapper">
              <img
                src={require(`../../assets/images/about/mission.jpg`).default}
                alt="Mission"
                className="img-fluid mission-image"
              />
            </div>
          </div>
          <div className="col-lg-7 col-md-12">
            <div className="about-content">
              <h2 className="sub-title blue-text">Mission</h2>
              <p className="about-mission">
                We intend to achieve our vision by having an end-to-end presence
                in the Navigation domain to support clients worldwide. Inspired
                by the spirit of scientific research and design, we strive
                towards building high-value, reliable, and world-class
                NavIC-based products and solutions using our own indigenously
                developed processes and proprietary technologies.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
